/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAlbum = createReactComponent("album", "IconAlbum", [
  [
    "path",
    {
      d: "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M12 4v7l2 -2l2 2v-7", key: "svg-1" }]
]);

export { IconAlbum as default };
//# sourceMappingURL=IconAlbum.js.map
